import type React from "react";
import {
  Phone,
  Users,
  MessageSquare,
  Mail,
  RefreshCw,
  MapPin,
  CheckSquare,
  Clock,
} from "lucide-react";

export interface ActivityTypeConfig {
  value: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  colorClass: string;
}

export const ACTIVITY_TYPES: Record<string, ActivityTypeConfig> = {
  chamada: {
    value: "chamada",
    label: "Chamada",
    icon: Phone,
    colorClass: "text-blue-500 bg-blue-500/10 border-blue-500/20",
  },
  reuniao: {
    value: "reuniao",
    label: "Reunião",
    icon: Users,
    colorClass: "text-purple-500 bg-purple-500/10 border-purple-500/20",
  },
  whatsapp: {
    value: "whatsapp",
    label: "WhatsApp",
    icon: MessageSquare,
    colorClass: "text-emerald-500 bg-emerald-500/10 border-emerald-500/20",
  },
  email: {
    value: "email",
    label: "E-mail",
    icon: Mail,
    colorClass: "text-sky-500 bg-sky-500/10 border-sky-500/20",
  },
  "follow-up": {
    value: "follow-up",
    label: "Follow-up",
    icon: RefreshCw,
    colorClass: "text-amber-500 bg-amber-500/10 border-amber-500/20",
  },
  visita: {
    value: "visita",
    label: "Visita",
    icon: MapPin,
    colorClass: "text-rose-500 bg-rose-500/10 border-rose-500/20",
  },
  tarefa: {
    value: "tarefa",
    label: "Tarefa",
    icon: CheckSquare,
    colorClass: "text-gray-500 bg-gray-500/10 border-gray-500/20",
  },
};

export const getActivityTypeConfig = (type: string): ActivityTypeConfig => {
  return (
    ACTIVITY_TYPES[type] || {
      value: type,
      label: type || "Atividade",
      icon: Clock,
      colorClass: "text-muted-foreground bg-muted border-border",
    }
  );
};

export const PRIORITY_CONFIG = {
  alta: {
    label: "Alta",
    className: "text-red-500 bg-red-500/10 border-red-500/20",
  },
  media: {
    label: "Média",
    className: "text-amber-500 bg-amber-500/10 border-amber-500/20",
  },
  baixa: {
    label: "Baixa",
    className: "text-blue-500 bg-blue-500/10 border-blue-500/20",
  },
};
